<template>
<div>
    <!-- <a style="color: #000000; font-size: 24px; cursor: pointer; padding-top: 5px; margin-top:-2em; margin-right:0.6em;" href="/search"><span class="wn-icons-grp1"><i class="fa fa-search"></i></span></a> -->
    <a style="color: #ffffff; font-size: 20px; cursor: pointer; padding-top: 5px;" @click="dropMenu()"><i class="fa fa-ellipsis-v"></i></a>
    <!-- <div id="menu-nav" class="menu-nav" style="display:none; width:50%;border:1px solid #ddd;float:right;z-index:1000; margin-top:5px; margin-right:-1em;"> -->
    <div id="menu-nav" class="sidenav">
        <a href="javascript:void(0)" class="closebtn" @click="dropMenu()">&times;</a>
        <ul>
            <li v-if="loggedIn"><a href="/account" @click="hideMenu()"><b>{{user.user_name}}</b></a></li>
            <li v-if="loggedIn"><a href="/account" @click="hideMenu()"><i class="fa fa-user"></i> Account</a></li>
            <li><a href="/timeline" @click="hideMenu()"><i class="fa fa-shopping-bag"></i> Market</a></li>
            <li><a href="/orders" @click="hideMenu()"><i class="fa fa-book"></i> Orders</a></li>
            <li v-if="loggedIn"><a href="/wishlist" @click="hideMenu()"><i class="fa fa-heart"></i> Wishlist</a></li>
            <li v-if="loggedIn"><a href="/buypoint" @click="hideMenu()"><i class="fa fa-users"></i> Shop Together</a></li>
            <li v-if="loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-off"></i> Logout</a></li>
            <li v-if="!loggedIn"><a href="/login" @click="hideMenu()"><i class="fa fa-power-on"></i> Login</a></li>
            <li v-if="!loggedIn"><a href="/register" @click="hideMenu()"><i class="fa fa-power-on"></i> Register</a></li>
        </ul>
    </div>
</div>
</template>
<style>
.menu-nav {background: #ffffff;}
.sidenav ul {padding: 0;}
.sidenav ul li{display:block; list-style: none; text-align: left; margin:5px;}
.sidenav ul li a{
    text-align: left;
    /* width: 100%; */
    color: inherit;
    font-size: 14px;
    padding-left: 8px;
}
.sidenav ul li a i{padding-right: 0.7em;}

/*sidenav*/

.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  /* left: 0; */
  right: 0;
  background-color: #ffffff;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
</style>
<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'Account',
    data () {
        return {
            user:{},
            loggedIn:false,
        }
    },
    methods:{
        dropMenu(){
            // let m = document.getElementById("menu-nav").style.display;
            // if(m == "block"){
            //     document.getElementById("menu-nav").style.display = "none";
            // }else{
            //     document.getElementById("menu-nav").style.display = "block";
            // }

            let w = document.getElementById("menu-nav").style.width;
            if(w == "250px"){
                document.getElementById("menu-nav").style.width = "0px";
            }else{
                document.getElementById("menu-nav").style.width = "250px";
            }

            // document.getElementById("menu-nav").style.display = "block";
        },
        hideMenu(){
            document.getElementById("menu-nav").style.display = "none";
        },
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.loggedIn = true;
                    self.user = value;
                }
            });
        },

    },
    created: function () {
        this.preset();
    }
}
</script>





// WEBPACK FOOTER //
// account-menu.vue?46646b76